<template>
  <simulation-details-component></simulation-details-component>
</template>
<script>
import SimulationDetailsComponent from '@/components/SimulationDetailsComponent.vue'
export default {
  components: {
    SimulationDetailsComponent
  }
}
</script>
